// src/js/common/navigation-guard.js
//
// Lets a screen register a single guard that intercepts "navigate away" actions
// (e.g. the menu bar switching products). When no guard is registered,
// requestNavigation is a pass-through, so screens that don't opt in are unaffected.
let guard = null;

export const setNavigationGuard = fn => {
  guard = fn;
};

export const clearNavigationGuard = () => {
  guard = null;
};

export const requestNavigation = proceed => {
  if (guard) {
    guard(proceed);
  } else {
    proceed();
  }
};
